import React from 'react';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ChartTotal = ({ item, webText, active }) => {

    const [labels, setLabels] = React.useState([]);
    const [views, setViews] = React.useState([]);
    //const [graphData, setGraphData] = React.useState();

    React.useEffect(() => {
        //if (!item || !item.views || !item.views.users) return;
        let graphData;

        switch (active) {
            case 1:
              //setGraphData(item.views9999);
              graphData = item.views9999;
              break;
            case 2:
              //setGraphData(item.views1);
              graphData = item.views1;
              break;
            case 3:
              //setGraphData(item.views7);
              graphData = item.views7;
              break;
            case 4:
              //setGraphData(item.views30);
              graphData = item.views30;
              break;
            default:
              // do nothing
              break;
        };

        const newLabels = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""];
        const newViews = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        for (let i = 0; i < graphData.users.length; i++) {
          if (i === 20) break;
          newLabels[i] = ""; //item.views.users[i].user;
          newViews[i] = graphData.users[i].clicked; // Ensure property matches your data structure
        };

        setLabels(newLabels);
        setViews(newViews);
    }, [item, active]); // Only runs when `item` changes

    const data = {
      labels: labels, //['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'p9'],
      datasets: [
        {
          label: "Uživateľ",
          data: views, //[5, 4, 1, 3, 5, 7, 8, 9, 4],
          backgroundColor: 'rgba(0, 173, 181, 0.2)',
          borderColor: 'rgba(0, 173, 181, 1)',
          borderWidth: 1,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        title: {
          display: false,
        },
        legend: {
          position: 'top',
          display: false,
        },
        tooltip: {
          enabled: true,
        },
      },
    };

    return <Bar data={data} options={options} />;
};

export default ChartTotal;